export class Adjunto {
    constructor(
        public adjuId: number,
        public descripcion: string,
        public estado: string,
        public fechaCreacion: Date,
        public fechaModificacion: Date,
        public rutaAdjunto: string,
        public tipoContenido: string,
        public usuarioCreador: string,
        public usuarioModificador: string,
        public adjuIdAnterior: number,
        public rutaAdjuntoAnterior:string,
        public base64:string
      ) {}
}
